exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-wine-js": () => import("./../../../src/templates/wine.js" /* webpackChunkName: "component---src-templates-wine-js" */),
  "component---src-templates-winery-js": () => import("./../../../src/templates/winery.js" /* webpackChunkName: "component---src-templates-winery-js" */)
}

